
export default function Philosophy() {
  return (
    <section id="philosophy" className="py-24 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            私たちの理念
          </h2>
          <div className="w-20 h-1 bg-teal-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            きらりでは、すべての子どもが輝く可能性を持っていると信じています。遊びを通じた学びと思いやりのあるケアで、一人ひとりの個性を大切に育みます。
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
          <div className="order-2 md:order-1">
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              子ども中心の学び
            </h3>
            <p className="text-base text-gray-600 mb-6 leading-relaxed">
              子どもたちはそれぞれ異なるペースで成長し、学びます。経験豊富な保育士が、一人ひとりの興味や能力、発達段階に合わせた個別の学習体験を提供します。観察と関わりを通じて、自然な好奇心と生涯にわたる学びへの愛を育てます。
            </p>
            <p className="text-base text-gray-600 leading-relaxed">
              カリキュラムは、創造的な芸術活動、身体活動、社会性・情緒の発達、認知的な課題を統合し、全人的な成長をサポートします。多様性を尊重し、子どもたちが支え合うコミュニティの中で自分らしく表現できるよう励まします。
            </p>
          </div>
          <div className="order-1 md:order-2">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl h-96">
              <img
                src="https://static.readdy.ai/image/8d13d909127b965a1b96285c4b9af1e2/25b86220ecfb651f9cbaf807c7dd3511.jpeg"
                alt="子ども中心の学び"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <div className="relative rounded-2xl overflow-hidden shadow-2xl h-96">
              <img
                src="https://static.readdy.ai/image/8d13d909127b965a1b96285c4b9af1e2/22255ba0fefdbf68d4578b77f83aefe5.jpeg"
                alt="安心・安全な環境"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              安心・安全な環境
            </h3>
            <p className="text-base text-gray-600 mb-6 leading-relaxed">
              安全と心の健康は私たちの最優先事項です。施設は子どもの安全を第一に設計されており、セキュリティシステム、年齢に適した設備、丁寧に管理されたスペースを備えています。保育士と子どもの比率を低く保ち、一人ひとりに十分な注意とケアを提供します。
            </p>
            <p className="text-base text-gray-600 leading-relaxed">
              物理的な安全だけでなく、子どもたちが大切にされ、話を聞いてもらえ、尊重されていると感じられる情緒的に安心できる環境を育んでいます。温かく応答的な保育士が信頼関係を築き、子どもたちの自信、回復力、ポジティブな社会性の発達を支援します。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
